import Main from './components/Main';
import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { StateProvider } from "./state";
import reducer from "./reducer";
import ReactGA from 'react-ga';


function initializeReactGA() {
  ReactGA.initialize('UA-123791717-1');
  ReactGA.pageview('/homepage');
}

const App = () => {
  return (
    <StateProvider reducer={reducer}>
      <BrowserRouter>
            <Switch>
              <Route
                exact
                path="/"
                component={Main}       
              />
            </Switch>
      </BrowserRouter>
    </StateProvider> 
  )
}

export default App
